import React, { Component } from 'react';
import { connect } from 'react-redux';

import { message } from 'antd';
import { queryCustomInfo } from '@api/crm/crm';
import PageAdd from './PageAdd';

const PageEdit = Page =>
  class pageAdd extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data: {},
      };
    }

    componentDidMount() {
      const { uuid } = this.props.params;
      this.loadData(uuid);
    }

    loadData = uuid => {
      queryCustomInfo(uuid).then(res => {
        if (res.statusCode === 200) {
          const { data } = res;
          data.category = [data.category1, data.category2];
          data.region = [data.province, data.city];
          this.setState({ data });
        } else {
          message.error(res.message);
        }
      });
    };

    render() {
      const newPros = {
        data: this.state.data,
      };
      return <Page {...this.props} {...newPros} />;
    }
  };

export default connect(state => ({ organization: state.organization }))(PageEdit(PageAdd));



// WEBPACK FOOTER //
// ./src/components/crm/custom/PageEdit.js